import type { ReferenceRecord } from "../../components/reference/types";
import { readConfigEntry } from "./db";

export const buildReferenceCacheKey = (prefix: string, type: string) => `${prefix}/${type}`;

const normalizeString = (value: unknown): string => {
  if (typeof value !== "string") {
    return "";
  }
  return value.trim().toLowerCase();
};

const recordMatchesQuery = (record: ReferenceRecord, query: string): boolean => {
  if (!query) return true;
  const name = normalizeString(record.name);
  const code = normalizeString(record.code);
  if (name.includes(query) || code.includes(query)) {
    return true;
  }
  if (record.attributes) {
    return Object.values(record.attributes).some((value) => normalizeString(value).includes(query));
  }
  return normalizeString(record.id).includes(query);
};

export const isNavigatorOffline = () => typeof navigator !== "undefined" && !navigator.onLine;

export async function searchCachedReferences(
  cacheKey: string,
  params: { q?: string; limit?: number } = {},
): Promise<ReferenceRecord[] | null> {
  const entry = await readConfigEntry<ReferenceRecord[]>(cacheKey);
  if (!entry?.data || !Array.isArray(entry.data)) {
    return null;
  }
  const query = params.q ? normalizeString(params.q) : "";
  const filtered = query ? entry.data.filter((record) => recordMatchesQuery(record, query)) : entry.data;
  if (typeof params.limit === "number" && params.limit > 0) {
    return filtered.slice(0, params.limit);
  }
  return filtered;
}
